module.exports = {
  dark: "#2E3C57",
  accent: "#13C0F5",
  accentDark: "#0898c4",
  white: "#FFFFFF",
  background: "#FAFAFA",
}
